import React, { useState } from 'react';

import { Smartphone } from '@yandex-360/iconostasis/dist/icons/Smartphone';
import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import cn from 'classnames';

import { Modal } from '../..';
import { i18n } from '../../../helpers/i18n';
import CloseModalButton from '../../modal/close-button';
import { FooterButton, FooterButtonProps } from '../footer-button';
import footerCss from '../index.css';
import css from './index.css';

interface Props extends Pick<FooterButtonProps, 'mode'> {
    onClick?: () => void;
}

export const InstallMobileAppButton: React.FC<Props> = ({ onClick, ...props }) => {
    const [visible, setVisible] = useState(false);

    const onClose = () => setVisible(false);
    const handleButtonClick = () => {
        if (onClick) {
            onClick();
        }

        setVisible(true);
    };

    return (
        <div className={css.root}>
            <FooterButton
                {...props}
                size="md"
                content={i18n('common', 'install-mobile-app')}
                view="neutral"
                className={cn(footerCss.footerButton, footerCss.buttonInstallApp)}
                icon={<Smartphone variant="outline" size="md" />}
                onClick={handleButtonClick}
            />
            <ScopedTheme theme="light">
                <Modal className={css.modal} keepMounted={true} onClose={onClose} visible={visible} zIndex={3001}>
                    <CloseModalButton
                        type="round"
                        className={css.closeButton}
                        onClose={onClose}
                        ariaLabel={i18n('common', 'close-dialog')}
                    />
                    <div className={css.modalContent}>
                        <div className={css.qr} />
                        <div className={css.qrText}>{i18n('common', 'install-mobile-app-message')}</div>
                    </div>
                </Modal>
            </ScopedTheme>
        </div>
    );
};
